import { sanitize } from 'isomorphic-dompurify';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';

import { type TextStyleProps, textStyle } from '../base-text/base-text';

const Container = styled.div<TextStyleProps>`
  p,
  li,
  span {
    margin: 0;
    ${textStyle}
  }

  b {
    padding-top: ${toRem(10)};
  }

  ul {
    margin-bottom: ${toRem(10)};
  }
`;

export type SanitizedHTMLProps = {
  className?: string;
  html: string;
  lineHeight?: number;
};

/**
 * Sets inner HTML after sanitization.
 * @see file html-view-style.js in mobile-ui.
 */
const SanitizedHTML = ({ className, html, lineHeight }: SanitizedHTMLProps) => (
  // biome-ignore lint/security/noDangerouslySetInnerHtml: content is sanitized.
  <Container className={className} dangerouslySetInnerHTML={{ __html: sanitize(html) }} $lineHeight={lineHeight} />
);

export default SanitizedHTML;
